import { Box, Card, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { border, styled } from '@mui/system';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
// import EmployedIcon from '../../../images/employed_Icon.svg';
// import NotEmployedIcon from '../../../images/NotEmp_Icon.svg';
// import RetiredIcon from '../../../images/Retired.svg';
// import SelfEmployedIcon from '../../../images/selfEmp_icon.svg';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import { emplomentStyles as classes } from './EmploymentStyles';
import {
  EmployedIcon,
  NotEmployedIcon,
  RetiredIcon,
  SelfEmployedIcon,
} from '../../../images/svg/CustomizedSVG';

const EmpStatusCardComp = ({ handleCardClick, isBundleCompliance = false }) => {
  const { activeEmploymentStatus, employmentInformationErrors, theme } =
    useContext(LeadGenerationContext);
  const { t } = useTranslation();
  const themeMUI = useTheme();
  const styledClasses = ProductUIStyles(theme);
  const isMobile = useMediaQuery(themeMUI?.breakpoints?.down('sm'), {
    defaultMatches: true,
  });

  const StyledCard = styled(Card)(({ themes, isActive }) => ({
    borderRadius: isBundleCompliance ? '24px' : '6px',
    // border: '1px solid #E6E6E6',
    // background: '#FFF',
    backgroundColor: theme?.palette?.fieldsBackground?.main,
    border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
    color: theme?.palette?.primary?.main,

    cursor: 'pointer',
    transition: 'all 0.3s ease',
    // maxWidth: '150px',
    height:
      isBundleCompliance && activeEmploymentStatus && isMobile
        ? '84px'
        : isBundleCompliance && activeEmploymentStatus
        ? '120px'
        : '150px',
    width: '100%',
    textAlign: 'center',

    ...(isActive && {
      border: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
      backgroundColor: theme?.palette?.cardActiveBackground?.main,
    }),
  }));

  const EmployeeCardList = isBundleCompliance
    ? [
        {
          icon: <EmployedIcon color={theme?.palette?.orientalPrimary?.main} />,
          text: 'Employed',
        },
        {
          icon: <SelfEmployedIcon color={theme?.palette?.orientalPrimary?.main} />,
          text: 'Self Employed',
        },
        {
          icon: <RetiredIcon color={theme?.palette?.orientalPrimary?.main} />,
          text: 'Retired',
        },
        {
          icon: <NotEmployedIcon color={theme?.palette?.orientalPrimary?.main} />,
          text: 'Not Employed',
        },
      ]
    : [
        {
          icon: <EmployedIcon color={theme?.palette?.orientalPrimary?.main} />,
          text: 'Employed',
        },
        {
          icon: <SelfEmployedIcon color={theme?.palette?.orientalPrimary?.main} />,
          text: 'Self Employed',
        },
        {
          icon: <NotEmployedIcon color={theme?.palette?.orientalPrimary?.main} />,
          text: 'Not Employed',
        },
        {
          icon: <RetiredIcon color={theme?.palette?.orientalPrimary?.main} />,
          text: 'Retired',
        },
      ];

  return (
    <Grid
      container
      size={12}
      style={
        isBundleCompliance
          ? {
              display: 'flex',
              flexDirection: 'row',
              marginBottom: '-20px',
            }
          : { display: 'flex', flexDirection: 'row', marginTop: '25px', marginBottom: '30px' }
      }
      spacing={2}
    >
      {EmployeeCardList.map((item) => (
        <Grid
          size={
            isBundleCompliance && activeEmploymentStatus
              ? 3
              : isBundleCompliance
              ? 6
              : { xs: 6, md: 3, sm: 6, lg: 2.2 }
          }
        >
          <StyledCard
            tabIndex="0"
            variant="outlined"
            onClick={(e) => handleCardClick(e, item.text)}
            data-testid="employmentStatus_testid"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleCardClick(e, item.text);
              }
            }}
            aria-label={activeEmploymentStatus === item.text ? `${item.text} selected` : item.text}
            isActive={activeEmploymentStatus === item.text}
            isBundleCompliance={isBundleCompliance}
          >
            <Box component="div" sx={classes.employmentcardcontent}>
              {/* <Box component="img" src={item.icon} /> */}
              {item.icon}
              {isBundleCompliance && isMobile && activeEmploymentStatus ? (
                ''
              ) : (
                <Typography
                  variant="subtitle1"
                  sx={{ ...classes.employmentCardText, color: theme?.palette?.primary?.main }}
                >
                  {t(`${item.text}`)}
                </Typography>
              )}
            </Box>
          </StyledCard>
        </Grid>
      ))}
      <Grid size={12}>
        <Box
          component="span"
          sx={styledClasses.error_message_product}
          role="alert"
          data-testid="employmentStatus_errid"
        >
          {t(employmentInformationErrors?.employmentStatus, {
            defaultValue: employmentInformationErrors?.employmentStatus,
          })}
        </Box>
      </Grid>
    </Grid>
  );
};

export default EmpStatusCardComp;

EmpStatusCardComp.propTypes = {
  isBundleCompliance: PropTypes.bool,
  handleCardClick: PropTypes.func,
};
